module.exports = __webpack_public_path__ + "img/Terraform-5.af648995.png";